import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7448 10.7736V15.5157H19.3348C19.0455 17.0408 18.1771 18.3321 16.8747 19.2004L20.8487 22.284C23.1641 20.1467 24.5 17.0075 24.5 13.2783C24.5 12.4101 24.4221 11.5751 24.2773 10.7737L12.7448 10.7736Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.88237 15.3306L4.98607 16.0167L1.81345 18.488C3.8283 22.4843 7.95791 25.245 12.7446 25.245C16.0506 25.245 18.8224 24.1541 20.8485 22.284L16.8744 19.2004C15.7835 19.9351 14.392 20.3804 12.7446 20.3804C9.56088 20.3804 6.85592 18.232 5.88738 15.3377L5.88237 15.3306Z",
			fill: "#34A853"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.81343 7.51196C0.978589 9.15941 0.499969 11.0185 0.499969 12.9999C0.499969 14.9813 0.978589 16.8404 1.81343 18.4878C1.81343 18.4989 5.88776 15.3264 5.88776 15.3264C5.64286 14.5917 5.4981 13.8125 5.4981 12.9998C5.4981 12.187 5.64286 11.4078 5.88776 10.6732L1.81343 7.51196Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7448 5.63069C14.5482 5.63069 16.1512 6.25405 17.4313 7.45631L20.9378 3.94982C18.8116 1.96839 16.051 0.754944 12.7448 0.754944C7.95816 0.754944 3.8283 3.5045 1.81345 7.51198L5.88765 10.6734C6.85606 7.77912 9.56113 5.63069 12.7448 5.63069Z",
			fill: "#EA4335"
		})
	]
});
export default SvgGoogle;
